import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppLengthOfRentalAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		disableClearable
		label="Length of Rental"
		placeholder="Length of Rental"
		{...props}
	/>
}